import BackDropComponent from "@/components/BackDrop";
import { fetchWeightDisputeImageRequest, fetchWeightDisputeImageReset, uploadWeightDisputeRequest, } from "@/redux/actions";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Card, CardContent, Divider, Drawer, Grid, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../scss/main.scss";
import "./Shipment.scss";
const ClosedDisputeDetails = ({ isDetailsSliderOpen, setIsDetailsSliderOpen, selectedRowData, handleRejectDispute, handleAcceptDispute, }) => {
    const handleClose = () => {
        setIsDetailsSliderOpen(false);
    };
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const [packageLength, setPackageLength] = React.useState(null);
    const [packageWidth, setPackageWidth] = React.useState(null);
    const [packageHeight, setPackageHeight] = React.useState(null);
    const [packageWeight, setPackageWeight] = React.useState(null);
    const [packageLabel, setPackageLabel] = React.useState(null);
    const [downloadedFileExtension, setDownloadedFileExtension] = React.useState("pdf");
    const [downloadedFileKey, setDownloadedFileKey] = React.useState(null);
    const [orderId, setOrderId] = React.useState("");
    const [tenantId, setTenantId] = React.useState("");
    const downloadWeightDisputeState = useSelector((state) => state.getWeightDisputeImageReducer);
    const userProfileState = useSelector((state) => state.User);
    const WeightDisputeFileUploadState = useSelector((state) => state.weightDisputeFileUploadReducer);
    const dispatch = useDispatch();
    const fileInputRef = React.useRef(null);
    const [selectedFile, setSelectedFile] = React.useState(null);
    const handleUploadClick = () => {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    const handleFileChange = (event) => {
        var _a;
        const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file) {
            setSelectedFile(file);
        }
    };
    React.useEffect(() => {
        var _a;
        // setOrderId(selectedRowData?.orderId);
        setTenantId((_a = userProfileState === null || userProfileState === void 0 ? void 0 : userProfileState.data) === null || _a === void 0 ? void 0 : _a.companyId);
    }, []);
    React.useEffect(() => {
        if (WeightDisputeFileUploadState && WeightDisputeFileUploadState.data) {
            setIsBackOpenOpen(false);
            enqueueSnackbar("Carrier image uploaded successfully", {
                variant: "success",
            });
        }
        else if (WeightDisputeFileUploadState.error) {
            enqueueSnackbar("Unable to Upload image", {
                variant: "error",
            });
            setIsBackOpenOpen(false);
        }
    }, [WeightDisputeFileUploadState]);
    React.useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (selectedRowData) {
            setPackageLength(((_a = selectedRowData.sellerUploadedImages) === null || _a === void 0 ? void 0 : _a.packageLength) || null);
            setPackageWidth(((_b = selectedRowData.sellerUploadedImages) === null || _b === void 0 ? void 0 : _b.packageWidth) || null);
            setPackageHeight(((_c = selectedRowData.sellerUploadedImages) === null || _c === void 0 ? void 0 : _c.packageHeight) || null);
            setPackageWeight(((_d = selectedRowData.sellerUploadedImages) === null || _d === void 0 ? void 0 : _d.packageWeight) || null);
            setPackageLabel(((_e = selectedRowData.sellerUploadedImages) === null || _e === void 0 ? void 0 : _e.packageLabel) || null);
        }
    }, [selectedRowData]);
    const handleDownload = (data, extension) => {
        var _a, _b, _c, _d, _e;
        let type = extension === "pdf" ? "application/pdf" : extension === "png" ? "image/png" : `application/${extension}`;
        if (extension === "csv") {
            type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        }
        const blobData = data instanceof Uint8Array ? new Blob([data], { type }) : data;
        let fileName = "file"; // default
        switch (downloadedFileKey) {
            case "packageLength":
                fileName = ((_a = packageLength === null || packageLength === void 0 ? void 0 : packageLength.split("/").pop()) === null || _a === void 0 ? void 0 : _a.split(".")[0]) || "package-length";
                break;
            case "packageWidth":
                fileName = ((_b = packageWidth === null || packageWidth === void 0 ? void 0 : packageWidth.split("/").pop()) === null || _b === void 0 ? void 0 : _b.split(".")[0]) || "package-width";
                break;
            case "packageHeight":
                fileName = ((_c = packageHeight === null || packageHeight === void 0 ? void 0 : packageHeight.split("/").pop()) === null || _c === void 0 ? void 0 : _c.split(".")[0]) || "package-height";
                break;
            case "packageWeight":
                fileName = ((_d = packageWeight === null || packageWeight === void 0 ? void 0 : packageWeight.split("/").pop()) === null || _d === void 0 ? void 0 : _d.split(".")[0]) || "package-weight";
                break;
            case "packageLabel":
                fileName = ((_e = packageLabel === null || packageLabel === void 0 ? void 0 : packageLabel.split("/").pop()) === null || _e === void 0 ? void 0 : _e.split(".")[0]) || "package-label";
                break;
            default:
                break;
        }
        const url = window.URL.createObjectURL(blobData);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${fileName}.${extension}`;
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
    };
    React.useEffect(() => {
        if (downloadWeightDisputeState.data) {
            setIsBackOpenOpen(false);
            handleDownload(downloadWeightDisputeState.data, downloadedFileExtension);
            dispatch(fetchWeightDisputeImageReset());
        }
        else if (downloadWeightDisputeState.error) {
            enqueueSnackbar("Unable to download image", {
                variant: "error",
            });
            setIsBackOpenOpen(false);
        }
    }, [downloadWeightDisputeState]);
    const handleLabelFileDownload = (fileUrl, fileKey) => {
        setIsBackOpenOpen(true);
        const extensionMatch = fileUrl.match(/\.(\w+)$/);
        const extension = extensionMatch ? extensionMatch[1] : "pdf";
        setDownloadedFileExtension(extension);
        setDownloadedFileKey(fileKey);
        dispatch(fetchWeightDisputeImageRequest({
            filePath: fileUrl,
        }));
    };
    const renderCard = (label, fileUrl, keyId) => (React.createElement(Grid, { item: true, xs: 12, sm: 4, md: 4, key: keyId },
        React.createElement(Card, { variant: "outlined" },
            React.createElement(CardContent, { style: { textAlign: "center", position: "relative" } },
                fileUrl && (React.createElement("img", { src: require("../../../assets/order/humbleicons.svg").default, onClick: () => handleLabelFileDownload(fileUrl, keyId), style: { cursor: "pointer" }, alt: "Download icon" })),
                React.createElement(Typography, { variant: "body2", gutterBottom: true }, (() => {
                    const fileName = fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.split("/").pop();
                    if (!fileName)
                        return "No file uploaded";
                    return fileName.length > 12 ? fileName.slice(0, 12) + "..." : fileName;
                })()),
                React.createElement(Typography, { variant: "caption", display: "block" }, "max size 0.5 MB"))),
        React.createElement(Typography, { variant: "caption", display: "block", ml: 4 }, label)));
    const handleUploadFiles = () => {
        setIsBackOpenOpen(true);
        dispatch(uploadWeightDisputeRequest({
            file: selectedFile,
            orderId: orderId,
            tenantId: tenantId,
        }));
    };
    return (React.createElement(Drawer, { open: isDetailsSliderOpen, anchor: "right" },
        React.createElement(BackDropComponent, { open: isBackOpenOpen }),
        React.createElement(Box, { sx: { width: 600 }, role: "presentation" },
            React.createElement(Grid, { container: true, p: 3, gap: 2 },
                React.createElement(Grid, { item: true, container: true, justifyContent: "space-between", alignItems: "center" },
                    React.createElement(Typography, { variant: "h6", fontWeight: "bold", className: "m_font_size_14" }, "Please share the following details to help us resolve the discrepancy"),
                    React.createElement(CloseIcon, { className: "m_cursor_pointer", onClick: handleClose })),
                React.createElement(Divider, { className: "tr_divider" }),
                React.createElement(Grid, { item: true, xs: 12, sx: {
                        border: "1px solid #D9D9D9",
                        borderRadius: "16px",
                        padding: 2,
                        marginTop: 2,
                        backgroundColor: "#ffffff",
                    } },
                    React.createElement(Typography, { fontFamily: "Poppins", fontSize: "16px", fontWeight: 500, color: "#121114", mb: 2 }, "View shipment images"),
                    React.createElement(Grid, { container: true, spacing: 2 },
                        renderCard("Package Length", packageLength, "packageLength"),
                        renderCard("Package Width", packageWidth, "packageWidth"),
                        renderCard("Package Height", packageHeight, "packageHeight"),
                        renderCard("Package Weight", packageWeight, "packageWeight"),
                        renderCard("Package Label", packageLabel, "packageLabel")))))));
};
export default ClosedDisputeDetails;
